<div class="set-model">
  <h2 class="set-model__title">
    {{ 'monitoring.scanner.set-model.title' | translate }}
  </h2>

  <div>{{ 'monitoring.scanner.set-model.raw' | translate }}: {{ modalData.rawModel }}</div>

  <!-- Подсказка при выборе модели: что именно нашлось на устройстве. Формулировка намеренно
       нейтральная — значение ещё проходит серверные проверки, исполнение может не появиться. -->
  @if (modalData.referenceSpec) {
    <div class="set-model__reference">
      <span class="set-model__reference-label">
        {{ 'monitoring.scanner.set-model.reference' | translate }}
      </span>

      @if (referenceValue) {
        <span class="set-model__reference-value">{{ referenceValue }}</span>
      } @else if (modalData.referenceSpec.rawUnit) {
        <span class="set-model__reference-value">{{ modalData.referenceSpec.rawUnit }}</span>
      }

      @if (modalData.referenceSpec.source) {
        <span class="set-model__reference-source">{{ modalData.referenceSpec.source }}</span>
      }
    </div>
  }

  <ng-container [formGroup]="setModelForm">
    <mon-equipment-model-select
      formControlName="equipmentModelId"
      [fullWidth]="true"
      labelTranslateKey="monitoring.scanner.set-model.equipment-model"
    />

    <lib-button
      [disabled]="setModelForm.invalid"
      (click)="onSelectModel()"
    >
      {{ 'monitoring.scanner.set-model.set-action' | translate }}
    </lib-button>
  </ng-container>
</div>
